import vuexStore from "@/store/customSaveStore";
import { transferingLegalRecommendation } from "../../recommendation/legal/store";

/** TKP-200 m.16: meşru menfaat dil nesnesi ({tr,…}) ya da eski düz metin olabilir — metin kutusu için metin, kayıt için dil nesnesi. */
export const interestText = (v) => (typeof v === "string" ? v : v ? v.tr || v.en || v.de || v.fr || "" : "");
export const interestLocalized = (v) => (typeof v === "string" ? (v ? { tr: v, en: v, de: v, fr: v } : null) : v || null);

export const datasubjectTransfering = vuexStore({
  namespaced: true,
  path: "/datasubject-transfering",
  state: {
    editedDatasubject: null,
    editedDatasubjectTransfering: null,
    selectedMethods: [],
    selectedPreventions: [],
    selectedLegals: [],
    // TKP-27 / 6.2 (kriter 4): kopyalama kısayolu — sayfadaki mevcut aktarımlar
    copySources: [],
    copiedTransfering: null,
    // TKP-64: işleme→aktarım kısayolu — düzenlenen satırın işleme kayıtları
    processingLegalSource: [],
    ...transferingLegalRecommendation.state,
  },
  getters: {
    editedDatasubject: (state) => state.editedDatasubject,
    editedDatasubjectTransfering: (state) => state.editedDatasubjectTransfering,
    selectedMethods: (state) => state.selectedMethods,
    selectedPreventions: (state) => state.selectedPreventions,
    selectedLegals: (state) => state.selectedLegals,
    copySources: (state) => state.copySources,
    copiedTransfering: (state) => state.copiedTransfering,
    processingLegalSource: (state) => state.processingLegalSource,
    ...transferingLegalRecommendation.getters,
  },
  mutations: {
    editedDatasubject: (state, value) => {
      state.editedDatasubject = value;
    },
    editedDatasubjectTransfering: (state, value) => {
      state.editedDatasubjectTransfering = value;
      state.copiedTransfering = null;
      if (value) {
        state.selectedMethods = [...value.methods];
        state.selectedPreventions = [...value.preventions];
        state.selectedLegals = [
          ...value.legals.map((i) => ({
            ...i,
            legitimateInterestLocalized: interestLocalized(i.legitimateInterest),
            legitimateInterest: interestText(i.legitimateInterest),
          })),
        ];
      } else {
        state.selectedMethods = [];
        state.selectedPreventions = [];
        state.selectedLegals = [];
      }
    },
    ...transferingLegalRecommendation.mutations,
    copySources: (state, value) => (state.copySources = value ?? []),
    processingLegalSource: (state, value) => (state.processingLegalSource = value ?? []),
    /** Mevcut bir aktarımı forma kopyalar: seçimler dolar, `_id` taşınmaz (yeni kayıt), alanlar düzenlenebilir. */
    copyFrom: (state, transfering) => {
      const { _id, datasubject, ...rest } = transfering ?? {};
      state.editedDatasubjectTransfering = null;
      state.selectedMethods = [...(rest.methods ?? [])];
      state.selectedPreventions = [...(rest.preventions ?? [])];
      state.selectedLegals = (rest.legals ?? []).map((i) => ({ ...i, legitimateInterestLocalized: interestLocalized(i.legitimateInterest), legitimateInterest: interestText(i.legitimateInterest) }));
      state.copiedTransfering = { thirdParty: rest.thirdParty, note: rest.note };
    },

    addMethod: (state, value) => {
      if (Array.isArray(value)) {
        state.selectedMethods = [...value];
      } else {
        state.selectedMethods.push(value);
      }
    },
    removeMethod: (state, value) => (state.selectedMethods = [...state.selectedMethods.filter((i) => i._id != value._id)]),

    addPrevention: (state, value) => state.selectedPreventions.push(...(Array.isArray(value) ? value : [value])),
    removePrevention: (state, value) => (state.selectedPreventions = [...state.selectedPreventions.filter((i) => i._id != value._id)]),

    addLegal: (state, value) => {
      if (!state.selectedLegals.find((i) => i.legalReason.libraryItem._id == value.legalReason.libraryItem._id && i.purpose.libraryItem._id == value.purpose.libraryItem._id)) {
        state.selectedLegals.push(value);
      }
    },
    removeLegal: (state, value) => {
      state.selectedLegals = [
        ...state.selectedLegals.filter((i) => !(i.legalReason.libraryItem._id == value.legalReason.libraryItem._id && i.purpose.libraryItem._id == value.purpose.libraryItem._id)),
      ];
    },
    updateLegitimateInterest: (state, { legal, legitimateInterest }) => {
      const founded = state.selectedLegals.find((i) => i.legalReason._id == legal.legalReason._id);
      if (founded) {
        founded.legitimateInterest = legitimateInterest;
        founded.legitimateInterestLocalized = {
          tr: legitimateInterest,
          en: legitimateInterest,
          fr: legitimateInterest,
          de: legitimateInterest,
        };
      }
    },
  },

  actions: {
    ...transferingLegalRecommendation.actions,
  },
});
